import type {ModalDialogService} from 'shared/modal-dialogs';
import type {WalkerService} from 'shared/services';
import type {Auth, Department} from 'src/typings';
import type {PortaroConfiguration} from 'src/portaro';
import type {KpDepartmentsService} from 'src/features/departments/services/kp-departments.service';
import type ServerUrlsDataService from './server-urls.data-service';
import {isEmptyObject} from 'shared/utils/object-utils';
import {exists} from 'shared/utils/custom-utils';

declare global {
    interface Window {
        portaroConfiguration: PortaroConfiguration;
    }
}

export class CatalogueSelectionLoginListener {

    public static readonly serviceName = 'catalogueSelectionLoginListener';

    private catalogueSelectionOpened = false;

    /*@ngInject*/
    constructor(private serverUrlsDataService: ServerUrlsDataService,
                private modalDialogService: ModalDialogService,
                private kpDepartmentsService: KpDepartmentsService,
                private walker: WalkerService,
                private currentDepartment: Department) {
    }

    public async update(newAuth: Auth): Promise<void> {
        if (!newAuth.evided || this.catalogueSelectionOpened) {
            return;
        }

        // TODO: Remove this "soft FE department protection" when a better solution is implemented on BE
        if (window.portaroConfiguration.homeDepartmentRedirectAfterLogin && exists(newAuth.homeDepartment) && newAuth.homeDepartment.id !== this.currentDepartment.id) {
            document.body.style.opacity = '0'; // Soft-hide content before page reload - I don't want to show users anything on a department they don't have access to
            await this.kpDepartmentsService.changeCurrentDepartment(newAuth.homeDepartment);
            return;
        }

        // We don't want modal when home department redirect is enabled
        if (window.portaroConfiguration.homeDepartmentRedirectAfterLogin) {
            return;
        }

        const departmentsByUrls = await this.serverUrlsDataService.getDepartmentUrl();
        if (!isEmptyObject(departmentsByUrls)) {
            try {
                this.catalogueSelectionOpened = true;
                const catalogueUrl = await this.modalDialogService.openModalWindowAndGetPayload('catalogueSelection', departmentsByUrls).finally(() => this.catalogueSelectionOpened = false);
                this.walker.newPage(catalogueUrl);

                // get time to redirect
                return new Promise((resolve) => setTimeout(resolve, 2000));
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (e) {
                //
            }
        }
    }
}